import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LoginScreen } from '../screens/auth/LoginScreen';
import { RegisterScreen } from '../screens/auth/RegisterScreen';
import { ForgotPasswordScreen } from '../screens/auth/ForgotPasswordScreen';
import { ResetPasswordScreen } from '../screens/auth/ResetPasswordScreen';
import { VerifyEmailScreen } from '../screens/auth/VerifyEmailScreen';
import { AppHeader } from '../components/ui/AppHeader';

const Stack = createNativeStackNavigator();

export function AuthNavigator() {
  return (
    <Stack.Navigator
      screenOptions={{
        header: props => <AppHeader {...props} />,
        headerShown: true,
      }}
    >
      <Stack.Screen
        name='login'
        component={LoginScreen}
        options={{
          title: 'Login',
          headerLeft: () => null,
        }}
      />
      <Stack.Screen
        name='register'
        component={RegisterScreen}
        options={{ title: 'Create account' }}
      />
      <Stack.Screen
        name='forgotPassword'
        component={ForgotPasswordScreen}
        options={{ title: 'Forgot password' }}
      />
      <Stack.Screen
        name='resetPassword'
        component={ResetPasswordScreen}
        options={{ title: 'Reset password' }}
      />
      <Stack.Screen
        name='verifyEmail'
        component={VerifyEmailScreen}
        options={{ title: 'Verify email' }}
      />
    </Stack.Navigator>
  );
}
